/** @format */
import {CheckCircleOutline} from '@mui/icons-material';

import {useNavigate} from 'react-router-dom';

import {Trans} from 'react-i18next';

import {
  BigGreenText,
  CloseButton,
  Content,
  GoToProjectsButton,
  GreenIconWrap,
  InlineTextBox,
  MessageBox,
  MessageModalButtonsBox,
  ModalBgDecoration,
  RegularText,
  Root,
} from '../styles';

import bgImg from '../images/bg-green.svg';

interface Props {
  onClose: () => void;
}

const MessageResultModalContent = ({onClose}: Props) => {
  const navigate = useNavigate();

  const handleGoToProjects = () => {
    navigate('/grouping');
  };

  return (
    <Root>
      <Content>
        <MessageBox>
          <InlineTextBox>
            <GreenIconWrap>
              <CheckCircleOutline fontSize='large' />
            </GreenIconWrap>
            <BigGreenText>
              <Trans>Заявка принята</Trans>
            </BigGreenText>
          </InlineTextBox>

          <RegularText>
            <Trans>Мы получили заявку и свяжемся с вами в кратчайшие сроки</Trans>
          </RegularText>
        </MessageBox>

        <MessageModalButtonsBox>
          <CloseButton onClick={onClose}>
            <Trans>Закрыть</Trans>
          </CloseButton>
          <GoToProjectsButton onClick={handleGoToProjects}>
            <Trans>Перейти к проектам</Trans>
          </GoToProjectsButton>
        </MessageModalButtonsBox>
      </Content>

      <ModalBgDecoration>
        <img src={bgImg} alt='' />
      </ModalBgDecoration>
    </Root>
  );
};

export {MessageResultModalContent};
